/**
 * We should not import any server-related dependencies here.
 * This file is used both on the server and on the frontend.
 */

export const FORBIDDEN_ERROR_CODE = "forbidden";

/**
 * Stytch error codes use `_` as this is how API returns them.
 * See examples in https://stytch.com/docs/api/errors
 */

/**
 * The org has domains whitelisted but the email is not in the whitelist.
 */
export const STYTCH_EMAIL_NOT_IN_ALLOWLIST_ERROR_CODE =
  "stytch:invalid_email_for_jit_provisioning";
/**
 * The org does not have any domains whitelisted and the email is not explicitly invited.
 */

export const STYTCH_EMAIL_NOT_EXPLICITLY_ALLOWED_ERROR_CODE =
  "stytch:email_not_explicitly_allowed";

export const STYTCH_DUPLICATE_MEMBER_EMAIL_ERROR_CODE =
  "stytch:duplicate_member_email";

export const STYTCH_ORGANIZATION_SLUG_ALREADY_USED_ERROR_CODE =
  "stytch:organization_slug_already_used";

export const STYTCH_INVALID_DOMAIN_ERROR_CODE =
  "stytch:organization_settings_invalid_domain";

// ---

/**
 * Vercel error codes use `_` as this is how API returns them.
 * See examples in https://vercel.com/docs/rest-api/reference/errors
 */

export const VERCEL_INVALID_DOMAIN_ERROR_CODE = "vercel:invalid_domain";

export const VERCEL_DOMAIN_TAKEN_ERROR_CODE = "vercel:domain_taken";

export const VERCEL_NOT_FOUND_ERROR_CODE = "vercel:not_found";

export const VERCEL_FORBIDDEN_ERROR_CODE = "vercel:forbidden";

export const VERCEL_UNKNOWN_ERROR_CODE = "vercel:unknown";

// ---

export const EXTERNAL_TIMEOUT_ERROR_CODE = "external:timeout";
// ---

export const INTERFACES_DOMAIN_IN_USE_ERROR_CODE = "interfaces:domain-in-use";

export const INTERFACES_LIMITS_PROJECTS_ERROR_CODE =
  "interfaces:limits:projects";

export const INTERFACES_LIMITS_BLOCKS_PER_PAGE_ERROR_CODE =
  "interfaces:limits:blocks-per-page";

export const INTERFACES_SLUG_IN_USE_ERROR_CODE = "interfaces:slug-in-use";

export const INTERFACES_PAGE_SLUG_IN_USE_ERROR_CODE =
  "interfaces:page-slug-in-use";

export const INTERFACES_PERMISSIONS_ERROR_CODE = "interfaces:permissions:error";

// ---

export const TABLES_LIMITS_TOO_MANY_TABLES_ERROR_CODE =
  "tables:limits:too_many_tables";

export const TABLES_LIMITS_TOO_MANY_FIELDS_ERROR_CODE =
  "tables:limits:too_many_fields";

export const TABLES_LIMITS_TOO_MANY_RECORDS_ERROR_CODE =
  "tables:limits:too_many_records";

export const TABLES_PERMISSIONS_ERRORS_ERROR_CODE = "tables:permissions:errors";

export const TABLES_MISSING_ACCESS_TOKEN_ERROR_CODE =
  "tables:missing_access_token";

export const TABLES_RATE_LIMITING_ERROR_CODE = "tables:rate_limiting";

export const TABLES_UNKNOWN_ERROR_CODE = "tables:unknown";

// ---

export const BLOCK_CHATBOT_DIRECTIVE_TOO_LONG_ERROR_CODE =
  "block:chatbot:directive-too-long";

export const CHATBOTS_UNKNOWN_ERROR_CODE = "chatbots:unknown";

// --

export const AUTH_NOT_LOGGED_IN_ERROR_CODE = "auth:not-logged-in";

export const AUTH_PROJECT_SESSION_EXPIRED_ERROR_CODE =
  "auth:project-session-expired";

export const AUTH_INVALID_TOKEN_ERROR_CODE = "auth:invalid-token";

export const AUTH_INVALID_GRANT_ERROR_CODE = "auth:invalid-grant";

export const AUTH_INVALID_REFRESH_TOKEN_ERROR_CODE =
  "auth:invalid-refresh-token";

export const AUTH_OAUTH_TOKENS_NOT_FOUND_ERROR_CODE = "auth:oauth:no-tokens";

// ---

export const APP_VALIDATION_ERROR_CODE = "app:validation";

export const UNKNOWN_ERROR_CODE = "app:unknown";

// --

export const ZAPIER_AUTH_PUBLIC_KEY_NOT_FOUND_ERROR_CODE =
  "zapier:auth:public_key_not_found";

export const ZAPIER_AUTH_INVALID_GRANT_ERROR_CODE = "zapier:auth:invalid_grant";

export const ZAPIER_AUTH_INVALID_TOKEN_SESSION_ERROR_CODE =
  "zapier:auth:invalid_token:zapsession";

export const ZAPIER_AUTH_UNKNOWN_ERROR_CODE = "auth:unknown";

// --

export const GULLIVER_UNKNOWN_ERROR_CODE = "gulliver:unknown";

// --

export const ZSL_API_UNKNOWN_ERROR_CODE = "zsl:api:unknown";

// --

export const ZAPIER_AUTHENTICATIONS_UNKNOWN_ERROR_CODE =
  "zapier:authentications:unknown";

// --

export const INTERFACES_AUTH_GENERIC_ERROR_CODE = "interfaces:auth:error";

export const INTERFACES_COLLABORATOR_CANNOT_BE_CREATOR_ERROR_CODE =
  "interfaces:collaborators:cannot-be-creator";

export const INTERFACES_COLLABORATOR_ALREADY_EXISTS_ERROR_CODE =
  "interfaces:collaborators:collaborator-already-exists";

export const INTERFACES_COLLABORATOR_ACCOUNT_MEMBER_NOT_FOUND_ERROR_CODE =
  "interfaces:collaborators:account-member-does-not-exist";

export const INTERFACES_COLLABORATORS_CANNOT_DELETE_CREATOR_ERROR_CODE =
  "interfaces:collaborators:cannot-delete-creator";
